import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { prefersReducedMotion } from '../utils/reducedMotion';

gsap.registerPlugin(ScrollTrigger);

class Parallax {
  $el: JQuery<HTMLElement>;
  $parallaxEls: JQuery<HTMLElement>;
  start: string;

  constructor(el: HTMLElement) {
    this.$el = $(el);
    this.$parallaxEls = this.$el.is('[data-parallax]')
      ? this.$el
      : this.$el.find('[data-parallax]');
    this.start = this.$el.data('parallax-start') || 'top bottom';

    this.init();
  }

  init() {
    if (prefersReducedMotion()) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el.get(0),
        start: this.start,
        end: 'bottom top',
        scrub: 1,
      },
    });

    this.$parallaxEls.each((_, el) => {
      const $el = $(el);
      const amount = $el.data('parallax-amount') || '';
      const mobileAmount = $el.data('parallax-mobile-amount') || '';
      const desktopAmount = $el.data('parallax-desktop-amount') || '';

      tl.to(
        $el,
        {
          y: () => {
            const wWidth = window.innerWidth;
            let val = '';

            if (wWidth < 768 && mobileAmount) {
              val = mobileAmount;
            } else if (wWidth >= 768 && desktopAmount) {
              val = desktopAmount;
            } else {
              val = amount;
            }

            if (
              val.toString().includes('vw') ||
              val.toString().includes('px')
            ) {
              return val;
            } else {
              return `${val}%`;
            }
          },
        },
        0,
      );
    });
  }
}

export default Parallax;
